import { Link } from "@/components/Link";
import type { InstrumentDetail } from "../../types";
import { useAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TabLayout } from "../TabLayout";

export function InstrumentTestsTable({
  instrument,
}: {
  instrument: InstrumentDetail;
}) {
  const testSpecs = instrument?.testSpecs || [];

  const { options } = useAdminGridOptions(
    testSpecs,
    [
      {
        field: "name",
        headerName: "Name",
        flex: 1,
        minWidth: 200,
        cellRenderer: (params) => (
          <Link to="/admin/tests/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          id: params.data.id,
          name: params.data.name,
        }),
      },
      {
        field: "code",
        headerName: "Code",
        width: 140,
        maxWidth: 200,
      },
    ],
    { sideBar: undefined },
  );

  return (
    <TabLayout description="The following test specs are configured with this instrment">
      <div className="flex h-96">
        <AdminGrid {...options} />
      </div>
    </TabLayout>
  );
}
